import { formatDate } from "../../../../functions/dateTime/formatDate";
import { checkValue } from "../../../../functions/checkValue";
import {
  UserDetailItem,
  UserDetailsWrapper,
  UserInfoBoxTitle,
  UserBoxWrapper,
} from "./UserDialogUi";

const UserInfo = ({ userData }) => {
  return (
    <UserBoxWrapper>
      <UserInfoBoxTitle title="User Info" />
      <UserDetailsWrapper>
        <UserDetailItem label="Name" value={userData.fullName} />
        <UserDetailItem label="Email" value={userData.email} />
      </UserDetailsWrapper>
      <UserDetailsWrapper>
        <UserDetailItem label="Phone" value={userData.mobileNumber} />
        <UserDetailItem
          label="Alternate Phone"
          value={checkValue(userData.altPhoneNumber)}
        />
      </UserDetailsWrapper>
      <UserDetailsWrapper>
        <UserDetailItem label="Email" value={userData.email} />
        <UserDetailItem
          label="Date Of Birth"
          value={formatDate(userData.dob)}
        />
      </UserDetailsWrapper>
      <UserDetailsWrapper>
        <UserDetailItem label="Gender" value={userData.gender.name} />
        <UserDetailItem label="Bike Number" value={userData.bikeRegNumber} />
      </UserDetailsWrapper>
      <UserDetailsWrapper>
        <UserDetailItem
          label="Aadhar Card No."
          value={checkValue(userData.aadharCardNumber)}
        />
        <UserDetailItem
          label="Pan card No."
          value={checkValue(userData.panCardNumber)}
        />
      </UserDetailsWrapper>
    </UserBoxWrapper>
  );
};

export default UserInfo;
